import { Component, HostBinding } from '@angular/core';
import { DestroyComponent } from 'src/app/components/destroy/destroy.component';
import {ActivatedRoute, Params} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { DataFilterSubskrypcjeService } from 'src/app/services/data-filter-subskrypcje.service';
import { SubskrypcjeFiltr } from 'src/app/models/subskrypcje-filtr.model';
import { Location } from '@angular/common';
import { DataFilterPowiadomieniaService } from 'src/app/services/data-filter-powiadomienia.service';
import { PowiadomienieFiltr } from 'src/app/models/powiadomienie-filtr.model';

@Component({
  selector: 'app-subskrypcje',
  templateUrl: './subskrypcje.component.html',
  styleUrls: ['./subskrypcje.component.scss'],
})
export class SubskrypcjeComponent extends DestroyComponent {
  @HostBinding('@.disabled') disabled = true;
  showFilters: boolean = false;
  showSubsWithEvents = false;
  hideAdd = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private dataFilterSubskrypcjeService: DataFilterSubskrypcjeService,
    private dataFilterPowiadomieniaService: DataFilterPowiadomieniaService,
    private location: Location,
    ) {
    super();

    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: Params) => {
        this.hideAdd = params.hideAdd ? params.hideAdd === 'true' : null;
        if(params.hideAdd === 'true' || params.hideAdd === 'false') {
          this.dataFilterSubskrypcjeService.saveFilter(SubskrypcjeFiltr.filtrKey, null);
          this.dataFilterPowiadomieniaService.saveFilter(PowiadomienieFiltr.filtrKey, null);
        }
        this.showSubsWithEvents = params.setActive === 'true';
        if(this.hideAdd || this.showSubsWithEvents) {
          this.location.replaceState("");
        }
      });
  }
}
